import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FiMail, FiClock, FiCheckCircle } from 'react-icons/fi';

const PendingApprovalPage: React.FC = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-primary-100 to-yellow-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="card text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-yellow-100 p-6 rounded-full">
              <FiClock className="h-16 w-16 text-yellow-600" />
            </div>
          </div>
          
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Account Pending Approval
          </h2>
          
          <div className="space-y-4 text-gray-600 mb-6">
            <p className="text-lg">
              Thank you for registering as a Master Trader!
            </p>
            <p>
              Your account requires admin approval before you can access the platform.
            </p>
            <p>
              Please wait — once the admin accepts your request, you'll be notified at{' '}
              <span className="font-semibold text-gray-900">{email}</span> and allowed to log in.
            </p>
          </div>

          <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <FiCheckCircle className="h-5 w-5 text-primary-600 flex-shrink-0 mt-0.5" />
              <div className="text-left">
                <p className="text-sm font-medium text-primary-900 mb-1">What happens next?</p>
                <ul className="text-sm text-primary-700 space-y-1">
                  <li>• Admin will review your application</li>
                  <li>• You'll receive an email notification</li>
                  <li>• Once approved, you can log in and start trading</li>
                </ul>
              </div>
            </div>
          </div>

          <Link
            to="/login"
            className="btn-primary inline-flex items-center gap-2"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;

